import { Market, Query } from "../generated/nest-graphql";
import { GET_MARKETS } from "../graphql/queries/getMarkets";
import { useQuery } from "@apollo/client";
import { defaultTo } from "ramda";

export const useMarkets = (): Market[] => {
  const { data } = useQuery<Query, {}>(GET_MARKETS);
  return defaultTo(null)(data?.getMarketsV2);
};
